import type { AuthenticationFactor } from "@stytch/vanilla-js";

export const checkWalletCreated = (
  trustedMetadata?: Record<string, unknown>,
) => {
  if (!trustedMetadata) {
    return false;
  }

  if (trustedMetadata.wallets === undefined) {
    return false;
  }

  return true;
};

export const check2faRequired = (authFactors: AuthenticationFactor[]) => {
  if (!authFactors) {
    return true;
  }

  if (!authFactors.some((af) => af.type === "webauthn")) {
    return true;
  }

  if (authFactors.length < 2) {
    return true;
  }

  return false;
};
